<template>
  <div class="loading_container" v-if="loading">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only"></span>
    </div>
  </div>
  <div class="loading_container" v-else-if="has_profile">
    <div class="alert alert-info m-5 text-center">
      <strong> Você já se cadastrou na Virtap!<br /></strong>
      Redirecionando automaticamente para seu perfil...
    </div>
  </div>
</template>

<script>
import AssistantManager from "../../../js/services/assistant.js";
import StringUtils from "../../../js/utils/string.js";
import Config from "../../../../resources/config.js";

export default {
  components: {},

  created() {
    this.loadAssistantData();
  },

  data() {
    return {
      has_profile: false,
    };
  },

  computed: {
    loading() {
      return this.$store.state.loading;
    },
  },

  methods: {
    async loadAssistantData() {
      this.$store.commit("setLoading", true);

      try {
        let assistantData = await AssistantManager.getAssistantSignupData();
        if (!assistantData.logged_in) {
          location.href = Config.signupPage;
        } else if (assistantData.has_profile) {
          this.$store.commit("setLoading", false);
          this.has_profile = true;
          this.$nextTick(() => {
            setTimeout(() => {
              location.href = "/";
            }, 3000);
          });
        } else {
          location.href =
            Config.profilePage +
            "?nome=" +
            assistantData.name +
            "&email=" +
            assistantData.email_address;
        }
      } catch (error) {
        this.handleAPIError(error, null);
      }
    },
  },
};
</script>
